import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-chat-icon',
  templateUrl: './chat-icon.component.svg',
  styleUrls: ['chat-icon.component.scss'],
})
export class ChatIconComponent {
  @Input() height = 18;
  @Input() width = 18;
  @Input() color = '#fff';
}
